"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
var labels = {
  he: {
    more: 'עוד'
  },
  ar: {
    more: 'المزيد'
  },
  en: {
    more: 'More'
  }
};
exports.labels = labels;